import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ContentPassService } from 'src/app/services/content-pass.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
  selector: 'app-paid-pass-modal',
  templateUrl: './paid-pass-modal.component.html',
  styleUrls: ['./paid-pass-modal.component.scss']
})
export class PaidPassModalComponent implements OnInit {

  @Input('data') data: any;
  passes: any;
  passesIcons: any[] = [];
  lang: String = 'en';

  constructor(private UTS: UtilitiesService,
	private modalController: ModalController,
  private CPS: ContentPassService
  ) { }

  ngOnInit(): void {
	this.lang = this.UTS.getLocaleLanguage();
	this.passes = this.data?.passes || [];
  this.getPassesIcons();
  }
  getPassesIcons():any {
	if(this.passes?.length > 0){
		this.passesIcons = this.passes.map(pass => {
			let item = {
				key: this.lang == 'en' && pass?.skus[0]?.name ? pass?.skus[0]?.name : pass?.skus[0]?.nameAr ? pass?.skus[0]?.nameAr:pass?.skus[0]?.name, 
				value: this.lang == 'en' ? pass?.skus[0]?.['thumbnailImage'] : pass?.skus[0]?.['thumbnailImage']
			};
			return item;
		});
    this.CPS.setPaidPassesIcons(this.passesIcons);
	}
  console.log(this.passesIcons)
  }
  clickProceedNow(): void{
    this.modalController.dismiss({ proceedNow: true});
  }
  close(){
    this.modalController.dismiss();
  }

}
